import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from "react-redux";
import { SubmissionError } from 'redux-form';
import Dashboard from './../components/Menu/Dashboard'
import PropTypes from 'prop-types';
import ChargesForm from '../components/Wallet/ChargesForm';
import { getCustomerData } from "./../actions/customers";
import { sendRequestOLD, getQRPayment } from "./../actions/transactions";
import DialogOptions from '../components/Complements/DialogOptions';
import DialogImage from '../components/Complements/DialogImage';

// import DialogOTPRequest from '../components/Complements/DialogOTPRequest';
// import sendRequest from '../components/Complements/sendRequest';


class PaymentContainer extends Component {
    // para obtener la data del customer buscado
    constructor(props) {
      super(props);
      this.state = { owner: '', cedule: '', alert: false, email: '', form: {}, alertQR: false, img: '',
      message: '',
      type: '',
      openSnackbar: false,
      loading: false };
      // this.handleClick = this.handleClick.bind(this);
    }
    
    handleSubmit = (values) => {
        // console.log(values)
        this.setState({alertQR: false})
        this.setState({ alert: true, form: values })
    }
    handlePayType = (option) => {
        // console.log('handlePayType', option)
        const { serie, imei} = this.props.device
        if (option === 'cobrar') {
            this.setState({loading: true})
            return this.props.sendRequestOLD( this.props.device.serie, this.props.device.imei, this.state.form.cedule,
                this.state.form.amount, this.state.email, this.props.device.cedule,
                'COBROS', this.state.form.description).then(r => {
                    // console.log('wow resp ', r)
                    if (r.payload.State === 'v') {
                        this.props.handleOpenSnack('Solicitud realizada', 'success')
                        this.setState({openBackDrop: false})
                        this.props.history.push('/charges-tray')
                    }
                })
        } else if (option === 'QR') {
            return this.props.getQRPayment(serie, imei, this.state.form.cedule,
                this.state.form.amount, this.props.device.cedule, 'USERCOBRO', this.state.form.description)
                .then(({payload})=> {
                    this.setState({alert: false})
                    this.setState({ alertQR: true, img: payload.qr })
                    // console.log('la solicitud del qr es ', this.state)
                    // this.renderAlertQR(true, payload.qr)
                })
        }
        
        
    }
    findCustomer = (value) => {
        const { customers } = this.props
        // let customer = {}
        if (customers.length === 0) {
            this.props.getCustomerData(value).then(r => {
                // console.log('mi respuesta  ', r)
                if (r.error) {
                    throw new SubmissionError(r.payload)
                }
                const { first_name, second_name, surname, second_surname, cedule, email } = r.payload
                let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
                this.setState({ owner: Names, cedule, email })
                // customer = r.payload
            })
        } else {
            const getCustomer = customers.find(customer => customer.cedule === value);
            const { first_name, second_name, surname, second_surname, cedule, email } = getCustomer
                let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
            this.setState({ owner: Names, cedule, email })
        }
        // return customer
    }
    handleOnClick = () => {
        this.props.history.push('/customers')
    }
    handleOnSubmitSuccess = () => {
        //this.props.history.goBack()
    }

    handleOnCancel = () => {
        this.props.history.push('/')
    }

    handleOncloseSnack = () => {
        this.setState({ openSnackbar: false });
    }
    handleCloseBackDrop = () => {
        this.setState({openBackDrop: false})
    };
    /* handleOpenSnack = (message, type) => {
        this.setState({ openSnackbar: true, message, type });
    }*/ 

    renderBody = () => {    
        const { owner, cedule, alert, alertQR, img, loading } = this.state   
        return  <div>
                    <ChargesForm
                        classes = { this.props }
                        onSubmit = { this.handleSubmit }
                        onCancel = { this.handleOnCancel }
                        findCustomer = { this.findCustomer}
                        owner = { owner }
                        cedule = { cedule } 
                        alert = { this.renderAlert(alert) }
                        QR = { this.renderAlertQR(alertQR, img) }
                        loading = { loading }
                        // onSubmitSuccess = { this.handleOnSubmitSuccess }
                        />
                </div>
    }
    renderAlert = (open) => {        
        if (open) {
            return <DialogOptions title = 'Tipo de pago' subTitle = '' handlePayType = { this.handlePayType } />
        } else {
            return <div></div>
        }
    }
    

    renderAlertQR = (OpenQR, img) => {
        // console.log('entra al render de qr', OpenQR, img)
        if (OpenQR) {
            // console.log('deberia abrir y retornar')
            return <DialogImage title = 'Escanee el codigo' subTitle = ''
            image = {img}/>
        } else {
            return <div></div>
        }       
    }

    render() {
        return (
            <div>
                <Dashboard
                    title= "Dashboard"
                    body = { this.renderBody() }
                    multiple = { false }
                />
            </div>
        );
    }
}

PaymentContainer.propTypes = {
    handleOpenSnack: PropTypes.func.isRequired,
}

const mapState = (state) => {
    const customers = state.customers;
    const device = state.devices
    return { customers, device };
}

export default withRouter(connect(mapState, { getCustomerData, sendRequestOLD, getQRPayment } )(PaymentContainer));
// export default withRouter(PaymentContainer);